import React, { PropsWithChildren } from 'react'

import { hasNoChildren } from '../../utils'
import { DeviceWhiteCardBody } from '../styles'

interface DeviceWhiteCardBlockProps {
  order: number
}

function DeviceWhiteCard({
  children,
  order,
}: PropsWithChildren<DeviceWhiteCardBlockProps>) {
  if (hasNoChildren(children)) return null
  return <DeviceWhiteCardBody order={order}>{children}</DeviceWhiteCardBody>
}

export default DeviceWhiteCard
